
const digest = '45523abb1c73b2286c1cc620681de131e7cc905f6269e31b7f1aa77a14944424';
const classes = {"wrapper":"_wrapper_t8irt_1"};
const css = `._wrapper_t8irt_1 {
  overflow-x: hidden;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  